// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/index.js!./select2-bootstrap.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("051eac00", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/css/select2-bootstrap.min.css
// module id = 2269
// module chunks = 0